import createClient, { type Client } from "openapi-fetch";

import type { ApiClientOptions } from "./http.type";

/**
 * Convenience assembly over `openapi-fetch`. The returned client is the openapi-fetch one, so
 * consumers keep `.use()` / `.eject()` and per-request `middleware` to extend it locally.
 */
export const createApiClient = <TPaths extends object>({
  middleware = [],
  ...options
}: ApiClientOptions): Client<TPaths> => {
  const client = createClient<TPaths>(options);
  client.use(...middleware);
  return client;
};
